import Pusher from 'pusher-js';
import {
  isDevEnvironment,
  REACT_APP_PUSHER_KEY,
  REACT_APP_PUSHER_CLUSTER
} from '../config/environment';

let pusher: Pusher | null = null;

const getPusherClient = (): Pusher | null => {
  if (!REACT_APP_PUSHER_KEY || !REACT_APP_PUSHER_CLUSTER) {
    console.warn('No pusher credentials found');
    return null;
  }

  if (pusher) {
    return pusher;
  }

  Pusher.logToConsole = isDevEnvironment;

  pusher = new Pusher(REACT_APP_PUSHER_KEY, {
    cluster: REACT_APP_PUSHER_CLUSTER
  });

  return pusher;
};

export default getPusherClient;
